import { Box, Typography } from "@mui/material";

export const rollsetStatus = [
	{ name: "Empty", code: "E", color: "#F1F5F9", textColor: "#1F2937" }, // Very Light Gray - dark text
	{ name: "In Process", code: "P", color: "#EAB308", textColor: "#FFFFFF" }, // Traffic Light Yellow - white text
	{ name: "Ready", code: "R", color: "#16A34A", textColor: "#FFFFFF" }, // Traffic Light Green - white text
	{
		name: "Build in Progress",
		code: "A",
		color: "#EA580C",
		textColor: "#FFFFFF",
	}, // Traffic Cone Orange - white text
	{ name: "Completed", code: "C", color: "#2563EB", textColor: "#FFFFFF" }, // Calm Blue - white text
	{ name: "Signed Off", code: "S", color: "#9333EA", textColor: "#FFFFFF" }, // Authority Purple - white text
	{ name: "Installed", code: "I", color: "#1F2937", textColor: "#FFFFFF" }, // Black/Charcoal - white text
	{ name: "Need Attention", code: "N", color: "#DC2626", textColor: "#FFFFFF" }, // Bright Red - white text
];

export const RollStatusInfo = () => {
	return (
		<Box
			style={{
				display: "flex",
				flexWrap: "wrap",
				gap: "15px",
				padding: "10px",
			}}
		>
			{rollsetStatus.map((state) => (
				<Box
					key={state.code}
					style={{ display: "flex", alignItems: "center", gap: "5px" }}
				>
					<div
						style={{
							width: "12px",
							height: "12px",
							borderRadius: "50%",
							backgroundColor: state.color,
							border: state.code === "E" ? "1px solid #BDBDBD" : "none",
						}}
					></div>
					<Typography color="textSecondary" variant="subtitle2">
						{state.name}
					</Typography>
				</Box>
			))}
		</Box>
	);
};
